import { WeeklyReport } from '@/components/report/WeeklyReport'
import { ReportData } from '@/components/report/reportData'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { z } from 'zod'

/** 24 Oct 2026: the weekly report behind a private link (no login).
 *  The page reads the frozen snapshot from /r/<token>/data.json. */
export const Route = createFileRoute('/r/$token')({
  validateSearch: z.object({ print: z.coerce.number().optional().catch(undefined) }),
  component: PublicReport,
})

function PublicReport() {
  const { token } = Route.useParams()
  const { print } = Route.useSearch()
  const [state, setState] = useState<{ data?: ReportData; gone?: boolean }>({})
  useEffect(() => {
    let alive = true
    fetch(`/r/${encodeURIComponent(token)}/data.json${print ? '?view=0' : ''}`, { credentials: 'omit' })
      .then(async (r) => {
        if (!r.ok) throw new Error('gone')
        return ReportData.parse(await r.json())
      })
      .then((data) => alive && setState({ data }))
      .catch(() => alive && setState({ gone: true }))
    return () => {
      alive = false
    }
  }, [token, print])
  useEffect(() => {
    if (state.data) document.title = `${state.data.site_name} · Weekly site report`
    if (state.data && print) {
      const t = setTimeout(() => window.print(), 800)
      return () => clearTimeout(t)
    }
  }, [state.data, print])
  if (state.gone) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F7F3EB', color: '#292929', padding: 20, fontSize: 17 }}>
        This report is no longer available.
      </div>
    )
  }
  if (!state.data) return <div style={{ minHeight: '100vh', background: '#E9E4DA' }} />
  return <WeeklyReport data={state.data} photoSrc={(p) => `/r/${encodeURIComponent(token)}/p/${p.n}.jpg`} />
}
